import ForbiddenError from './error';
import env from './env';

export const fetchStarlinkTerminalUrl = async (url, token) => {
  return await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((response) => {
      // 200 | 403
      if (response.ok || response.status == 403) {
        return {
          status: response.status,
          message: response.json(),
        };
      }
      // ?
      throw response.json();
    })
    .then((response) => {
      if (response['status'] == 403) {
        throw new ForbiddenError(response['message']['detail']);
      } else {
        return response['message'];
      }
    })
    .catch((error) => {
      if (error instanceof ForbiddenError) {
        throw error;
      }
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const fetchStarlinkTerminal = async (terminalId, customerId, token) => {
  const url =
    env('REACT_APP_BACKEND_URL') +
    '/v4/starlink/terminals/' +
    terminalId +
    '?customer_id=' +
    customerId;
  return await fetchStarlinkTerminalUrl(url, token);
};

export const fetchStarlinkTerminalUtilisation = async (
  terminalId,
  customerId,
  token,
  timeframe = null,
  from_dt = null,
  to_dt = null,
) => {
  const params = new URLSearchParams({ customer_id: customerId });
  if (timeframe) params.set('timeframe', timeframe);
  if (from_dt) params.set('from_dt', from_dt);
  if (to_dt) params.set('to_dt', to_dt);
  const url =
    env('REACT_APP_BACKEND_URL') +
    '/v4/starlink/terminals/' +
    terminalId +
    '/utilisation?' +
    params.toString();
  return await fetchStarlinkTerminalUrl(url, token);
};

export const fetchStarlinkTerminalTelemetry = async (terminalId, customerId, token) => {
  const url =
    env('REACT_APP_BACKEND_URL') +
    '/v4/starlink/terminals/' +
    terminalId +
    '/telemetry' +
    '?customer_id=' +
    customerId;
  return await fetchStarlinkTerminalUrl(url, token);
};

export const fetchStarlinkTerminalTopup = async (terminalId, customerId, token) => {
  const url =
    env('REACT_APP_BACKEND_URL') +
    '/v4/starlink/terminals/' +
    terminalId +
    '/topup' +
    '?customer_id=' +
    customerId;
  return await fetchStarlinkTerminalUrl(url, token);
};
